export default "__VITE_ASSET__f74a4f79__"